import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const HolidaysForm = (props) => {
  const frmRef = useRef({});

  const { sendRequest: postHolidays } = useHttp();

  const [holidaysData, setHolidaysData] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [selectedYearId, setSelectedYearId] = useState("");
  const [update, setUpdate] = useState(false);

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const offset = currentPage * itemsPerPage;

  const displayedItems =
    holidaysData && holidaysData.slice(offset, offset + itemsPerPage);

  const submitHandler = (e) => {
    e.preventDefault();

    let d = moment(frmRef.current.date.value).format("DD/MM/YYYY");

    if (!update) {
      const isHolidayExists =
        holidaysData && holidaysData.some((holiday) => holiday.date == d);
      if (isHolidayExists) {
        toast.error("Holiday exists for this Date.");
        return;
      }
    }

    const data = {
      date: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      holidayName: frmRef.current.holiday.value,
      financialYearId: frmRef.current.financialYear.value,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId, 
    };

    if (update) {
      data["yearlyHolidayId"] = update.yearlyHolidayId;
    }

    postHolidays(
      {
        url: "/api/yearHoliday/",
        method: update ? "PUT" : "POST",

        body: data,
      },
      (data) => {
        toast.success(`Holidays Data ${update ? "Updated" : "Added"}`);
        frmRef.current.date.value = "";
        setSelectedYearId("");
        frmRef.current.holiday.value = "";
        props.addForm(false);
        HolidaysDetail();
      }
    );
  };

  const { sendRequest: getHolidaysDetail } = useHttp();

  const HolidaysDetail = () => {
    getHolidaysDetail(
      {
        url: `/api/yearHoliday/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        const sortedHolidaysData =
          res &&
          res.sort((a, b) => {
            const dateA = moment(a.date, "DD/MM/YYYY");
            const dateB = moment(b.date, "DD/MM/YYYY");
            return dateB - dateA;
          });

        setHolidaysData(sortedHolidaysData);
      }
    );
  };

  useEffect(() => {
    HolidaysDetail();
  }, [getHolidaysDetail]);

  const { sendRequest: getYears } = useHttp();
  useEffect(() => {
    getYears(
      {
        url: `/api/financialYear/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        setYears(res);
      }
    );
  }, []);

  useEffect(() => {
    const filterdData =
      years && years.filter((item) => item.financialYearId == selectedYearId);

    setSelectedFinancialYear(filterdData[0]);
  }, [selectedYearId]);

  useEffect(() => {
    const startDate =
      selectedFinancialYear && selectedFinancialYear.financialYearStartDate;

    setMinDate(startDate);

    const endDate =
      selectedFinancialYear && selectedFinancialYear.financialYearEndDate;
    setMaxDate(endDate);
  }, [selectedFinancialYear]);

  const handleEdit = (data) => {
    setUpdate(data);

    frmRef.current.holiday.value = data.holidayName;
    const parts = data.date && data.date.split("/");
    if (parts && parts.length === 3) {
      const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
      frmRef.current.date.value = formattedDate;
    }
    setSelectedYearId(data.financialYearId);
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Holiday Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Financial Year</label>

                        <select
                          id="financialYear"
                          className="form-control"
                          ref={(el) => (frmRef.current["financialYear"] = el)}
                          required
                          onChange={(e) => setSelectedYearId(e.target.value)}
                          value={selectedYearId}
                        >
                          <option value="">Select</option>
                          {years &&
                            years.map((x) => (
                              <option
                                key={x.financialYearId}
                                value={x.financialYearId}
                              >
                                {x.financialYearName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date </label>
                        <input
                          type="date"
                          id="date"
                          className="form-control"
                          ref={(el) => (frmRef.current["date"] = el)}
                          required
                          min={moment(minDate).format("MM/DD/YYYY")}
                          max={maxDate}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Holiday </label>
                        <input
                          type="text"
                          id="holiday"
                          className="form-control"
                          ref={(el) => (frmRef.current["holiday"] = el)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default HolidaysForm;
